/** @jsx jsx */
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Flex, Heading, jsx, Text } from 'theme-ui'
import { getPackUrl } from '~/utils/packs'

const AwardPackCard = ({ pack, isTrade }) => {
  const { awards, id, mainImage, name } = pack

  return (
    <Box pt={7} sx={{ height: '100%' }}>
      <Flex
        bg="white"
        pt={2}
        px={2}
        sx={{ borderRadius: '8px', flexDirection: 'column', height: '100%' }}
      >
        <Box sx={{ flexGrow: '1' }}>
          <Box
            mt={-9}
            mb={2}
            sx={{
              borderRadius: '50%',
              height: '200px',
              overflow: 'hidden',
              width: '200px',
            }}
          >
            <GatsbyImage
              image={mainImage.gatsbyImageData}
              alt={mainImage.description}
              sx={{ height: 'auto', width: '100%' }}
            />
          </Box>
          <Heading as="h3" variant="title4">
            {name}
          </Heading>
          {awards && (
            <Box mx={-2}>
              {awards.map((award, i) => (
                <Box key={`pack-${id}-award-${award.id}`}>
                  <AwardPackCardAward
                    award={award}
                    hasBorder={i !== awards.length - 1 || !isTrade}
                  />
                </Box>
              ))}
            </Box>
          )}
        </Box>
        {!isTrade && (
          <Box mb={2} sx={{ a: { variant: 'text.textLink' } }}>
            <Link to={getPackUrl(pack)}>{`Shop ${name}`}</Link>
          </Box>
        )}
      </Flex>
    </Box>
  )
}

const AwardPackCardAward = ({ award, hasBorder }) => {
  const { awardTitle, competition, image } = award
  const isCompetition = !['Wine Spectator', 'Wine Enthusiast'].includes(
    competition
  )

  return (
    <Flex
      my={2}
      pb={isCompetition && 2}
      px={2}
      sx={{
        alignItems: 'center',
        backgroundColor: !isCompetition ? 'backgroundMedium' : 'transparent',
        position: 'relative',
        '&:after':
          hasBorder && isCompetition
            ? {
                borderBottom: '1px solid',
                borderColor: 'greyLight',
                bottom: '0',
                clear: 'both',
                content: "''",
                display: 'block',
                left: '16px',
                position: 'absolute',
                right: '16px',
              }
            : {},
      }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          flexGrow: '1',
          justifyContent: 'center',
          minHeight: '88px',
        }}
      >
        <Heading as="h4" variant="title6" mb="4px">
          {awardTitle}
        </Heading>
        <Text as="p" variant="description" color="greyDark">
          {competition}
        </Text>
      </Flex>
      <Box ml={1} sx={{ flexShrink: '0', width: '88px' }}>
        {image && (
          <GatsbyImage
            image={image.gatsbyImageData}
            alt={image.description}
            sx={{ height: 'auto', width: '100%' }}
          />
        )}
      </Box>
    </Flex>
  )
}

export default AwardPackCard
